<template>
  <div class="Eliminar">
    <div class="banner"></div>
    <div class="content">
      <div style="display: flex">
        <img class="img38" src="@/assets/home/img38.png" />
        <div class="glob">
          <div style="margin-bottom: 30px">
            Estimado cliente, si encuentra algún problema, puede contactarnos en
            cualquier momento a través de:
            <span style="color: #1b67c8">servicio@zorionasofom.com.</span>
            Resolveremos su problema lo antes posible. Estamos aquí para
            servirle, por favor, danos una oportunidad.
          </div>
          <div>
            Si aún desea eliminar sus datos, ingrese el número de teléfono con
            el que accederás a la aplicación a continuación y haz clic en
            'Enviar'. Procesaremos su solicitud en un plazo de 3 a 5 días
            hábiles. ¡Gracias!
          </div>
        </div>
      </div>
      <div class="phone-box">
        <div class="movil">Número de teléfono móvil</div>
        <div class="phone">
          <div class="qianzhui">+52</div>
          <input
            class="phone-input"
            type="number"
            v-model="phone"
            oninput="if(value.length>10)value=value.slice(0,10)"
            placeholder="Por favor, ingrese el número de teléfono celular del que desea eliminar los datos."
          />
        </div>
      </div>
      <div
        class="Enviar"
        :style="phone.length === 10 ? 'opacity: 1;' : ''"
        @click="Confirmar"
      >
        Enviar
      </div>
    </div>

    <transition name="slide-fade" @after-enter="hideElement">
      <div class="success" v-if="showSuccess">
        <img class="yes" src="@/assets/home/yes.png" />
        <div>Se ha enviado con éxito</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Eliminar',
  components: {},
  data() {
    return {
      phone: '',
      showSuccess: false,
    };
  },
  methods: {
    Confirmar() {
      if (this.phone.length === 10) {
        this.showSuccess = true;
        this.phone = '';
      }
    },
    hideElement() {
      setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.banner {
  height: 474px;
  background: linear-gradient(180deg, #9bbce7 0%, #c5dbf7 42%, #eff6ff 100%);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: -1;
}
.qianzhui {
  width: 80px;
  font-size: 22px;
  color: #000000;
  border-right: 1px solid #d6d6d6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 26px;
}
.phone-input {
  margin-left: 10px;
  font-size: 22px;
  color: #565656;
  border: none;
  outline: none;
  flex: 1;
  background-color: transparent;
}
/* 隐藏输入框上下箭头 */
.phone-input::-webkit-inner-spin-button,
.phone-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 兼容Firefox */
.phone-input[type='number'] {
  -moz-appearance: textfield;
}

.Enviar {
  width: 464px;
  height: 64px;
  background: linear-gradient(270deg, #287bdb 0%, #1156b9 100%);
  border-radius: 43px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  line-height: 64px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
  opacity: 0.5;
  margin-bottom: 100px;
}

.slide-fade-enter-active {
  transition: opacity 1s;
}
.slide-fade-enter {
  opacity: 0;
}

.success {
  height: 46px;
  padding: 0 58px;
  background: #ffffff;
  border-radius: 32px;
  display: flex;
  align-items: center;
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  border: 1px solid #10ce5f;
  font-size: 16px;
  color: #000000;
}

.img38 {
  width: 459px;
  height: 418px;
}
.glob {
  width: 819px;
  height: 349px;
  background-image: url('@/assets/home/img39.png');
  background-size: 100% 100%;
  font-size: 22px;
  color: #000000;
  line-height: 30px;
  padding: 61px;
}
.phone-box {
  height: 188px;
  background-image: url('@/assets/home/img40.png');
  background-size: 100% 100%;
  padding: 30px 30px;
  box-sizing: border-box;
  margin-bottom: 55px;
}
.content {
  padding: 20px 360px;
}
.movil {
  font-size: 22px;
  color: #000000;
}
.phone {
  display: flex;
  margin-top: 35px;
}
.yes {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}
</style>
